export function formatDate(date) {
	let formatedDate = date.split('T')[0].split('-');

	return `${formatedDate[2]}/${formatedDate[1]}/${formatedDate[0]}`;
}

export function formatDateWithHour(date) {
	let formatedDate = date.split('T')[0].split('-');
	let formatedHours = date.split('T')[1].split(':');

	return `${formatedDate[2]}/${formatedDate[1]}/${formatedDate[0]} ${formatedHours[0]}:${formatedHours[1]}`;
}
